import React, { FC, HTMLAttributes } from 'react'
import { Box, BoxProps } from '@chakra-ui/core'

export interface Props extends HTMLAttributes<BoxProps> {}

export const Card: FC<Props> = ({ children, ...props }) => {
  return (
    <Box
      d="flex"
      flexDir="column"
      borderRadius="4px"
      backgroundColor="white"
      boxShadow="0px 2px 8px rgba(215, 215, 215, 0.5)"
      padding="8px"
      h="100%"
      w="100%"
      {...props}
    >
      {children}
    </Box>
  )
}
